const DoubleImageCarousel = {
  parts: [
    'container',
    'wrapper',
    'leftImageContainer',
    'image',
    'rightColumn',
    'rightImageContainer',
    'content',
    'title',
    'description'
  ],
  baseStyle: {
    container: {
      width: 'full',
    },
    wrapper: {
      display: 'flex',
      flexDirection: {base: 'column', lg: 'row'},
      alignItems: {base: 'flex-end', lg: 'flex-start'},
      gap: {base: '48px', lg: '110px'}, // 48px mobile, 110px desktop
      maxWidth: '1440px',
      mx: 'auto',
      py: {base: 10, lg: 20},
      pl: {base: 5, lg: 0}, // 20px mobile, 0 desktop
      pr: {base: 0, lg: 20}, // 0 mobile, 80px desktop
    },
    leftImageContainer: {
      width: {base: 'full', lg: '59.5588%'},
      height: 'auto',
      aspectRatio: '1/1',
      flexShrink: 0,
      position: 'relative',
      flex: {base: 'none', lg: '0 0 59.5588%'},
    },
    image: {
      width: 'full',
      height: 'full',
      objectFit: 'cover',
      objectPosition: 'center',
      aspectRatio: '1/1',
    },
    rightColumn: {
      display: 'flex',
      flexDirection: {base: 'row', lg: 'column'},
      alignItems: 'flex-start',
      gap: {base: 5, lg: 13}, // 20px mobile, 52px desktop
      width: {base: 'full', lg: 'calc(40.4412% - 110px)'},
      pr: {base: 5, lg: 0}, // 20px mobile, 0 desktop
      flexShrink: 0,
      flex: {base: 'none', lg: '0 0 calc(40.4412% - 110px)'},
    },
    rightImageContainer: {
      width: {base: '44.5%', lg: 'full'},
      height: 'auto',
      aspectRatio: '1/1',
      flexShrink: 0,
      position: 'relative',
      flex: {base: '0 0 44.5%', lg: 'none'},
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 2, lg: 4}, // 8px mobile, 16px desktop
      flex: {base: '1 0 0', lg: 'none'},
      alignSelf: 'stretch',
    },
    title: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale80', // rgba(27, 26, 24, 0.80)
      fontFamily: 'heading',
      fontSize: {base: 'lg', lg: '2xl'}, // 18px mobile, 24px desktop
      fontStyle: 'normal',
      fontWeight: 'medium',
      lineHeight: {base: '160%', lg: '140%'}, // 160% mobile, 140% desktop
    },
    description: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale80', // rgba(27, 26, 24, 0.80)
      fontFamily: 'body',
      fontSize: {base: 'md', lg: 'lg'}, // 16px mobile, 18px desktop
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '160%', // 160%
    },
  },
  variants: {
    default: {},
    reverse: {
      wrapper: {
        pr: {base: 5, lg: 0}, // 20px mobile, 0 desktop
        pl: {base: 0, lg: 20}, // 0 mobile, 80px desktop
      },
      leftImageContainer: {
        order: {base: 1, lg: 2},
      },
      rightColumn: {
        order: {base: 2, lg: 1},
        pl: {base: 5, lg: 0}, // 20px mobile, 0 desktop
        pr: 0,
      },
      rightImageContainer: {
        order: {base: 2, lg: 1},
      },
      content: {
        order: {base: 1, lg: 2},
      },
    },
  },
};

export default DoubleImageCarousel;
